import { Card, CardContent, Box, Typography, Stack } from "@mui/material"

export default function SimpleKpiCard(props) {
    const { caption, metric, color } = props

    return (
        <Card
            sx={{
                position: "relative",
                overflow: "hidden",
                borderRadius: 2,
            }}
        >
            {color && (
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: 5,
                        bgcolor: color,
                    }}
                />
            )}

            <CardContent sx={{ display: 'flex', mt: 0.5 }}>
                <Stack spacing={1} sx={{ textAlign: 'start' }}>
                    <Typography variant="h4">
                        {caption}
                    </Typography>
                    <Typography variant="h2" fontWeight="bold">
                        {metric}
                    </Typography>
                </Stack>
            </CardContent>
        </Card>
    )
}